import React, { useMemo } from 'react';
import c from 'classnames';

import Box from '../../Box';
import Divider from '../../Divider';
import { MenuDividerProps } from './types';

const DEFAULT_CLASSES = {
  divider: '-mx-12',
  root: 'py-2',
};

const MenuDivider: React.FC<React.PropsWithChildren<MenuDividerProps>> = (props) => {
  const { classes: classesProp, className } = props;
  const classes = useMemo(() => ({ ...DEFAULT_CLASSES, ...classesProp }), [classesProp]);

  return (
    <Box className={c(classes.root, className)}>
      <Divider className={classes.divider} />
    </Box>
  );
};

export { MenuDividerProps };
export default React.memo(MenuDivider);
